import { HTTP } from '../../utils'

export const populateTaskMonitor = (taskId) => {
  return HTTP().get('/longRunningTasks/monitor?id=' + taskId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateYourUploadHistory = () => {
  return HTTP().get('/longRunningTasks/monitorAll')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateInstitutionUploadHistory = () => {
  return HTTP().get('/longRunningTasks/monitorAllInstitutions')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/taskMonitor/api.js